"use client";

import Image from "next/image";
import Link from "next/link";
import { PractitionerCard } from "@/components/practitioner-card";
import { useSavedPractitionersQuery } from "@/features/saved-practitioners";
import { withBasePath } from "@/lib/base-path";
import { routes } from "@/lib/routes";

const EmptyState = () => (
  <div className="relative flex flex-col items-start justify-center gap-32 overflow-hidden rounded-medium border border-neutral-black/5 bg-neutral-white p-32 lg:p-80">
    <div className="flex flex-col gap-8">
      <h1 className="text-32 leading-[1.3] font-semibold text-neutral-black">Your saved list is empty</h1>
      <p className="max-w-398 text-14 leading-[1.4] text-neutral-black/70">
        When you find a practitioner you&apos;d like to revisit, save them here for easy access anytime.
      </p>
    </div>

    <Link href={routes.home.url} className="text-16 font-medium leading-[1.4] text-brand-blue hover:underline">
      Find a Practitioner
    </Link>

    <Image
      src={withBasePath("/main-auth-background.svg")}
      alt=""
      aria-hidden
      unoptimized
      width={233}
      height={233}
      className="pointer-events-none absolute top-1/2 right-32 hidden -translate-y-1/2 opacity-50 lg:block"
    />
  </div>
);

export default function SavedPage() {
  const { practitioners, isPending } = useSavedPractitionersQuery();

  return (
    <section className="mx-auto flex max-w-1280 flex-col gap-24 px-16 pt-(--public-header-height) pb-32 lg:gap-32 lg:px-80 lg:pt-[calc(var(--public-header-height)+64px)] lg:pb-64">
      {!isPending && practitioners.length > 0 && (
        <p className="text-18 leading-[1.4] text-neutral-black/70">
          You have{" "}
          <span className="font-medium text-neutral-black">
            {practitioners.length} practitioner{practitioners.length === 1 ? "" : "s"}
          </span>{" "}
          saved
        </p>
      )}

      {isPending ? (
        <>
          <PractitionerCard loading />
          <PractitionerCard loading />
        </>
      ) : practitioners.length === 0 ? (
        <EmptyState />
      ) : (
        practitioners.map((practitioner) => (
          <PractitionerCard key={practitioner.username} source={practitioner} />
        ))
      )}
    </section>
  );
}
